<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'CustomerList' }" class="nav-link">Klienci</router-link>/Nowy klient</h2></page-title>
      <div class="col page-element">        
        <alert-loading v-if="loading"></alert-loading>
        <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>
        <CustomerForm v-if="!loading" :handle-submit="create" :values="item" :errors="violations"></CustomerForm>
      </div>
	</b-container>
</template>

<script>
  import CustomerForm from './Form.vue';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    components: {
      CustomerForm
    },
    data: function() {
      return {
        item: {
          address: {},
          contact: {},
          bankAccount: {}
        }
      }
    },
    computed: mapGetters({
      error: 'customer/create/error',
      loading: 'customer/create/loading',
      created: 'customer/create/created',
      violations: 'customer/create/violations'
    }),
    methods: {
      create: function(item) {
        this.$store.dispatch('customer/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'CustomerList' });
        }
      }
    },
    created() {
      this.$store.dispatch('customer/create/reset');
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?68d82570